var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"requestsReceived"},[_c('DataTable',{attrs:{"type":"responce","title":"我收到的需求"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }